/**
 * Illustrations — small inline-SVG line-art for hero empty states.
 * Brand rules: ink (#3a4a66/#7a7060) outlines, single gold (#b8973a) accent,
 * teal (#145f5f) secondary. No external images; each ~1-2KB, crisp at 2x.
 * Keep the set tiny and reuse — these are moments, not decoration.
 */

const base = { fill: 'none', strokeWidth: 1.6, strokeLinecap: 'round', strokeLinejoin: 'round' };

/** Empty portfolio — a building with a gold "add" spark. */
export function IlloPortfolio({ width = 132 }) {
  return (
    <svg width={width} viewBox="0 0 132 96" aria-hidden="true">
      <rect x="34" y="22" width="44" height="62" rx="3" stroke="#7a7060" {...base} />
      <path d="M34 34h44M46 22v-8h20v8" stroke="#7a7060" {...base} />
      {[46, 58, 70].map((x) => (
        <g key={x} stroke="#a39a88" {...base}>
          <rect x={x - 4} y="42" width="8" height="8" rx="1.5" />
          <rect x={x - 4} y="58" width="8" height="8" rx="1.5" />
        </g>
      ))}
      <path d="M50 84v-10h12v10" stroke="#7a7060" {...base} />
      <path d="M22 84h88" stroke="#3a4a66" {...base} strokeWidth="2" />
      {/* gold add-spark */}
      <circle cx="96" cy="30" r="13" fill="#fdf6e4" stroke="#b8973a" {...base} />
      <path d="M96 24.5v11M90.5 30h11" stroke="#b8973a" {...base} strokeWidth="2" />
      <path d="M112 16l2.5 2.5M115 12l1 1M110 10.5l1.5 1.5" stroke="#d4b05a" {...base} />
    </svg>
  );
}

/** All clear — shield with a gold check, calm laurels. */
export function IlloAllClear({ width = 132 }) {
  return (
    <svg width={width} viewBox="0 0 132 96" aria-hidden="true">
      <path d="M66 14l28 10v22c0 18-12 30-28 36-16-6-28-18-28-36V24l28-10z" fill="#f6faf9" stroke="#145f5f" {...base} strokeWidth="1.8" />
      <path d="M53 47l9 9 17-19" stroke="#b8973a" {...base} strokeWidth="2.4" />
      <path d="M20 64c4-1 7-4 8-8M112 64c-4-1-7-4-8-8" stroke="#a39a88" {...base} />
      <path d="M14 72c5-1 9-4 11-9M118 72c-5-1-9-4-11-9" stroke="#c2bba8" {...base} />
    </svg>
  );
}

/** No documents — parchment stack with gold seal. */
export function IlloDocuments({ width = 132 }) {
  return (
    <svg width={width} viewBox="0 0 132 96" aria-hidden="true">
      <rect x="40" y="20" width="46" height="58" rx="4" fill="#fdfbf6" stroke="#7a7060" {...base} transform="rotate(-4 63 49)" />
      <rect x="46" y="16" width="46" height="58" rx="4" fill="#ffffff" stroke="#3a4a66" {...base} />
      <path d="M55 30h28M55 40h28M55 50h18" stroke="#a39a88" {...base} />
      <circle cx="82" cy="62" r="9" fill="#fdf6e4" stroke="#b8973a" {...base} />
      <path d="M78.5 62l2.5 2.5 4.5-5" stroke="#b8973a" {...base} strokeWidth="1.8" />
      <path d="M79 70l-2 8 5-3 5 3-2-8" stroke="#b8973a" {...base} />
    </svg>
  );
}

/** No results — magnifier over a calm horizon. */
export function IlloSearch({ width = 132 }) {
  return (
    <svg width={width} viewBox="0 0 132 96" aria-hidden="true">
      <circle cx="60" cy="44" r="22" fill="#fdfbf6" stroke="#3a4a66" {...base} strokeWidth="1.8" />
      <path d="M76 60l16 16" stroke="#3a4a66" {...base} strokeWidth="2.4" />
      <path d="M50 44a10 10 0 0 1 10-10" stroke="#b8973a" {...base} />
      <path d="M20 82h92" stroke="#c2bba8" {...base} />
    </svg>
  );
}
